import { dom, library } from '@fortawesome/fontawesome-svg-core'

// Used for USPs
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faRulerTriangle } from '@fortawesome/pro-solid-svg-icons/faRulerTriangle'
import { faWrench } from '@fortawesome/pro-solid-svg-icons/faWrench'
import { faCabinetFiling } from '@fortawesome/pro-solid-svg-icons/faCabinetFiling'
import { faStars } from '@fortawesome/pro-solid-svg-icons/faStars'
import { faHandshakeAlt } from '@fortawesome/pro-solid-svg-icons/faHandshakeAlt'
import { faMagic } from '@fortawesome/pro-solid-svg-icons/faMagic'
import { faTruck } from '@fortawesome/pro-solid-svg-icons/faTruck'
import { faCouch } from '@fortawesome/pro-solid-svg-icons/faCouch'
import { faLamp } from '@fortawesome/pro-solid-svg-icons/faLamp'
import { faBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding'
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt'

// Other icons
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight'
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp'
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown'
import { faDownload } from '@fortawesome/pro-light-svg-icons/faDownload'
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faQuoteLeft } from '@fortawesome/pro-light-svg-icons/faQuoteLeft'
import { faTag } from '@fortawesome/pro-light-svg-icons/faTag'
import { faFile } from '@fortawesome/pro-light-svg-icons/faFile'
import { faFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf'
import { faFileImage } from '@fortawesome/pro-light-svg-icons/faFileImage'
import { faExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink'
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'

// Social Media icons
import { faThumbsUp } from '@fortawesome/pro-regular-svg-icons/faThumbsUp'
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn'
import { faXing } from '@fortawesome/free-brands-svg-icons/faXing'


library.add(
    // USPs
    faRulerTriangle, faWrench, faCabinetFiling, faStars, faHandshakeAlt, faMagic, faTruck, faCouch,
    faLamp, faBuilding, faMapMarkerAlt,

    // Other
    faAngleLeft, faAngleRight, faAngleUp, faAngleDown, faDownload, faPhone, faEnvelope, faQuoteLeft, faTag,
    faFile, faFilePdf, faFileImage, faCheck, faExternalLink, faPaperPlane, faCircle, faChevronRight,

    // Social Media icons
    faThumbsUp, faTwitter, faInstagram, faYoutube, faLinkedinIn, faXing
)
dom.watch()
